import Vue from 'vue';
import HttpMixin from '@/mixins/HttpMixin';
import flatPickr from 'vue-flatpickr-component';
import VueSimpleSpinner from "vue-simple-spinner";
import {UserRoleEnum} from '@/enums/userRolesEnum';
import { BallPulseLoader } from 'vue-loaders';
import {getReportByName, ReportRegister} from "@/components/reports/reportRegistry";
import {downloadFile} from "@/utils/downloadUtil";
import {HTTP} from "@/utils/httpCommonUtil";

export default Vue.component('report', {
  name: 'Report',
  mixins: [ HttpMixin ],
  components: {
    VueSimpleSpinner,
    flatPickr,
    BallPulseLoader
  },
  props: {
    reportName: {
      type: String,
      required: true
    },
    inputParams: {
      type: Object
    },
    displaySummary: {
      type: Boolean,
      default: true
    },
    inputParamsValid: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      reportRegister: {} as ReportRegister,
      isAuthorized: false,
      searchParametersCardExpanded: true,
      loadingSearchResults: false,
      transactionTypes: [] as any[],
      UserRoleEnum: UserRoleEnum,
      startDate: '',
      endDate: '',
      useReceiptDates: false,
      useInvoicePeriods: true,
      type: -1,
      results: {},
      metadata: {},
      tableResults: [],
      resultsExpanded: false,
      ourConfig: null
    };
  },
  computed: {
    hasInputParameters(): boolean {
      return Object.keys(this.inputParams).length > 0;
    }
  },
  beforeMount: function () {
    this.reportRegister = getReportByName(this.reportName);
    this.isAuthorized = this.$store.getters['user/hasRole'](this.reportRegister.roles);
  },
  methods: {
    async pullReport() {
      try {
        this.loadingSearchResults = true;
        const data = await (this as any).httpPost(`/reports/${this.reportRegister.path}`, 'Failed to load Report', this.inputParams);
        if (data) {
          this.results = data.results;
          this.metadata = data.metadata;
          this.tableResults = data.tableResults;
          this.resultsExpanded = true;
        } else {
          this.results = {};
          this.tableResults = [];
        }
      } catch(err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred pulling this report.'
        });
      } finally {
        this.loadingSearchResults = false;
      }
    },
    async download() {
      try {
        this.loadingSearchResults = true;
        const response = await HTTP.post(`/api/reports/${this.reportRegister.path}/csv`, this.inputParams);
        const fileName = `${this.reportRegister.path}.csv`;
        downloadFile(response.data, fileName)
      } catch (err) {
        let type = 'error';
        let title = 'warning';
        let message = 'Error downloading data.';
        if (err.response && err.response.status === 400) {
          type = 'warning';
          title = 'Warning';
          message = err.response.data.message;
        }
        this.$notify({
          group: 'main',
          type,
          title,
          text: message,
        });
      } finally {
        this.loadingSearchResults = false;
      }
    },
    clearAll() {
      this.$emit("clearInputParams")
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/reports/Report.ts